/**
 * Front page "Our Work v2": category filter tabs, card slider arrows and tab-strip arrows.
 */
document.addEventListener('DOMContentLoaded', function () {
    var tabBtns = document.querySelectorAll('.our-work-v2 .tab-btn');
    var cards = document.querySelectorAll('.our-work-v2 .portfolio-card');

    // Filter aliases: some cards use the long slug, some the short one
    var aliases = {
        'website': 'website-development',
        'website-development': 'website',
        'pa': 'paid-ads',
        'paid-ads': 'pa',
        'smm': 'social-media',
        'social-media': 'smm'
    };

    function showCard(card) {
        card.style.display = 'block';
        setTimeout(function () {
            card.style.opacity = '1';
            card.style.transform = 'translateY(0)';
        }, 50);
    }

    function hideCard(card) {
        card.style.opacity = '0';
        card.style.transform = 'translateY(20px)';
        setTimeout(function () { card.style.display = 'none'; }, 300);
    }

    tabBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
            var filter = this.getAttribute('data-filter');

            // Sync every button (desktop + offcanvas) with the same filter
            tabBtns.forEach(function (b) {
                b.classList.toggle('active', b.getAttribute('data-filter') === filter);
            });

            // Close offcanvas if inside one
            var offcanvasEl = this.closest('.offcanvas');
            if (offcanvasEl && typeof bootstrap !== 'undefined') {
                var bsOffcanvas = bootstrap.Offcanvas.getInstance(offcanvasEl) || new bootstrap.Offcanvas(offcanvasEl);
                if (bsOffcanvas) bsOffcanvas.hide();
            }

            cards.forEach(function (card) {
                var isMatch = filter === 'all' ||
                    card.classList.contains('cat-' + filter) ||
                    (aliases[filter] && card.classList.contains('cat-' + aliases[filter]));
                if (isMatch) {
                    showCard(card);
                } else {
                    hideCard(card);
                }
            });
        });
    });

    var grid = document.querySelector('.our-work-v2__grid');
    var prevBtn = document.querySelector('.our-work-v2__slider-nav .slider-arrow--prev');
    var nextBtn = document.querySelector('.our-work-v2__slider-nav .slider-arrow--next');

    if (grid && prevBtn && nextBtn) {
        [[prevBtn, -1], [nextBtn, 1]].forEach(function (pair) {
            pair[0].addEventListener('click', function () {
                var card = grid.querySelector('.portfolio-card');
                if (card) grid.scrollBy({ left: pair[1] * (card.offsetWidth + 20), behavior: 'smooth' });
            });
        });
    }

    // Tabs strip arrows
    var tabsContainer = document.querySelector('.our-work-v2__tabs .tabs-container');
    var tabsPrevBtn = document.querySelector('.our-work-v2__tabs .tabs-arrow--prev');
    var tabsNextBtn = document.querySelector('.our-work-v2__tabs .tabs-arrow--next');
    if (!tabsContainer || !tabsPrevBtn || !tabsNextBtn) return;

    tabsPrevBtn.addEventListener('click', function () {
        tabsContainer.scrollBy({ left: -250, behavior: 'smooth' });
    });
    tabsNextBtn.addEventListener('click', function () {
        tabsContainer.scrollBy({ left: 250, behavior: 'smooth' });
    });

    function setArrowState(btn, enabled) {
        btn.style.opacity = enabled ? '1' : '0.5';
        btn.style.pointerEvents = enabled ? 'auto' : 'none';
    }

    function updateTabsArrows() {
        var overflowing = tabsContainer.scrollWidth > tabsContainer.clientWidth;
        tabsPrevBtn.style.display = overflowing ? 'flex' : 'none';
        tabsNextBtn.style.display = overflowing ? 'flex' : 'none';
        if (!overflowing) return;

        setArrowState(tabsPrevBtn, tabsContainer.scrollLeft > 0);
        setArrowState(tabsNextBtn, Math.ceil(tabsContainer.scrollLeft + tabsContainer.clientWidth) < tabsContainer.scrollWidth);
    }

    tabsContainer.addEventListener('scroll', updateTabsArrows);
    window.addEventListener('resize', updateTabsArrows);
    setTimeout(updateTabsArrows, 100);
});
